import { apiGet, apiPost } from "shared/services/apiRequest";

export const getAuditTrailService = async (filter, limit = 1000) =>
    (await apiPost('/audits/search', { limit, offset: 0, filter }))?.data;

export const getCommandNumberService = async (actionType) =>
    (await apiGet(`/audits/command-number?actionType=${actionType}`))?.commandNumber;

export const getAllUsers = async () =>
    (await apiGet(`/users`))?.data;

export const postAuditTrailLogService = async (data) =>
    (await apiPost('/audits/', data))?.data;
